import React from 'react'
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import Chatbox from '../../layout/common/Chatbox';
import Footer from '../../layout/common/Footer';
import Header from '../../layout/common/Header';
import NavHeader from '../../layout/common/NavHeader';
import SidebarTest from '../../layout/common/SidebarTest';
import EditFaq from '../../layout/faq/EditFaq';

const EditFAQ = () => {
  const [showChtBox, setShowChtBox] = useState(false);
  const chtBoxHandler = (e) => {
    setShowChtBox(!e);
  };
  const chatboxClose = (e) => {
    setShowChtBox(!e);
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>Edit Faq's</title>
      </Helmet>
      <NavHeader />
      <Header onClick={chtBoxHandler} showChtBox={showChtBox} />
      <Chatbox showChtBox={showChtBox} chatboxClose={chatboxClose} />
      <SidebarTest />
      <EditFaq />
      <Footer />
    </React.Fragment>
  )
}

export default EditFAQ
